export const queryParser = {
    parseVersion: function(query) {
        let version = parseInt(query.version)
        return isNaN(version) ? 0 : version;
    },
    parseLocation: function(query) {
        return (Number.isNaN(query.lat) || Number.isNaN(query.lon)) ? null
            : { lat: Number.parseFloat(query.lat), lng: Number.parseFloat(query.lon) };
    },
    parseDateString: function(dateString) {
        var regEx = /^\d{4}\d{2}\d{2}$/;
        if(!dateString.match(regEx)) return [false, null, 'Invalid format'];  // Invalid format
        let d = new Date(Date.UTC(parseInt(dateString.substring(0,4)), 
                                  parseInt(dateString.substring(4,6)) - 1, 
                                  parseInt(dateString.substring(6,8))));
        let dNum = d.getTime();
        if(!dNum && dNum !== 0) return [false, null, 'NaN value']; // NaN value, Invalid date
        let isoDateString = dateString.substring(0,4) + '-'
            + dateString.substring(4,6) + '-' + dateString.substring(6,8);
        return [ d.toISOString().slice(0,10) === isoDateString, d, 'OK' ];
    },
    parseDate: function(query) {
        let dd = this.parseDateString(String(query.dt));
        return dd[1];
    },
    parsePrevious: function(query) {
        let previous = null;
        try {
            previous = JSON.parse(atob(query.previous));
        }
        // eslint-disable-next-line no-empty
        catch(e) {
        }
        if (previous && previous.id && previous.id.time) {
            // previous.id.timeString = previous.id.time;
            previous.id.time = new Date(Date.parse(previous.id.time));
        }
        return previous;
    },
    parseQuery: function(query) {
        let queryData = {
            hrcid: query.hrcid,
            location: this.parseLocation(query),
            date: this.parseDate(query),
            version: this.parseVersion(query),
            source: query.source,
            caller: query.caller,
            returnUrl: query.ret,
            previous: this.parsePrevious(query)
        }
        return queryData;
    }
}
